import Mock from '@/mocks/Mock'
import { Present } from '@/models/Present'
import { PresentParams } from '@/repositories/present-repository'

export default class HistoryMock extends Mock<Present> {
  constructor() {
    super('present')
  }

  get(params: PresentParams) {
    console.log(params)

    return this.data
  }
}
